export const urgentStyle = (urgent) => ({
  color: urgent ? "#e91e63" : "black",
  fontWeight: urgent ? "bold" : "normal",
  textDecoration: urgent ? "underline" : "initial",
});
